import facebookIcon from '@/shared/assets/images/facebook-100.png';
import xIcon from '@/shared/assets/images/x-100.png';
import youtubeIcon from '@/shared/assets/images/youtube-100.png';
import pinterestIcon from '@/shared/assets/images/pinterest-100.png';
import instagramIcon from '@/shared/assets/images/instagram-100.png';

interface FollowUsProps {
  variant?: 'desktop' | 'mobile';
}

export default function FollowUs({ variant = 'desktop' }: FollowUsProps) {
  const socialLinks = [
    {
      name: 'Facebook',
      href: 'https://www.facebook.com/bluestonejewels',
      icon: <img src={facebookIcon} alt="Facebook" className={`${variant === 'desktop' ? 'w-4 h-4' : 'w-5 h-5'}`} />,
    },
    {
      name: 'X (Twitter)',
      href: 'https://twitter.com/bluestone_com',
      icon: <img src={xIcon} alt="X (Twitter)" className={`${variant === 'desktop' ? 'w-4 h-4' : 'w-5 h-5'}`} />,
    },
    {
      name: 'YouTube',
      href: 'https://www.youtube.com/user/Bluestonedotcom',
      icon: <img src={youtubeIcon} alt="YouTube" className={`${variant === 'desktop' ? 'w-4 h-4' : 'w-5 h-5'}`} />,
    },
    {
      name: 'Pinterest',
      href: 'https://in.pinterest.com/bluestonedotcom/',
      icon: <img src={pinterestIcon} alt="Pinterest" className={`${variant === 'desktop' ? 'w-4 h-4' : 'w-5 h-5'}`} />,
    },
    {
      name: 'Instagram',
      href: 'https://www.instagram.com/bluestone_jewellery/',
      icon: <img src={instagramIcon} alt="Instagram" className={`${variant === 'desktop' ? 'w-4 h-4' : 'w-5 h-5'}`} />,
    },
  ];

  if (variant === 'mobile') {
    return (
      <div className="text-center mb-6">
        <h3 className="text-sm font-medium mb-3">FOLLOW US ON</h3>
        <div className="w-16 h-px bg-white/30 mx-auto mb-4"></div>
        <div className="flex justify-center gap-3">
          {socialLinks.map((link) => (
            <a
              key={link.name}
              href={link.href}
              target="_blank"
              rel="noopener nofollow"
              className="w-10 h-10 rounded-full bg-white flex items-center justify-center hover:bg-gray-100 transition-colors"
              aria-label={link.name}
            >
              {link.icon}
            </a>
          ))}
        </div>
      </div>
    );
  }

  // Desktop variant
  return (
    <div className="flex items-center gap-4">
      <span className="text-sm text-white/80">Follow us on</span>
      <div className="flex gap-2">
        {socialLinks.map((link) => (
          <a
            key={link.name}
            href={link.href}
            target="_blank"
            rel="noopener nofollow"
            className="w-8 h-8 rounded-full bg-white flex items-center justify-center hover:bg-gray-100 transition-colors"
            aria-label={link.name}
          >
            {link.icon}
          </a>
        ))}
      </div>
    </div>
  );
}

